import { ctrlKeyLabel } from '@/constants/keyCodes'

export default key => {
  switch (key) {
    case 'Ctrl-<return>':
      return [ctrlKeyLabel, 'enter']
    case 'Ctrl-.':
      return [ctrlKeyLabel, '.']
    case 'Ctrl-<delete>':
      return [ctrlKeyLabel, 'Delete']
    case '<return>':
      return ['enter']
    case '<escape>':
      return ['esc']
    case '<up>':
      return ['↑']
    case '<down>':
      return ['↓']
    case '<left>':
      return ['←']
    case '<right>':
      return ['→']
    default:
      return [key]
  }
}
